module.exports = __webpack_public_path__ + "static/media/06_before.c41035a5.jpg";